const zIndex = {
  base: 0,
  search: 1000,
  navigation: 2000,
  contribute: 3000,
  dialog: 4000
} as const;
export default zIndex;
